import { IMedia } from '@websolutespa/bom-core';
import { createContext, useContext } from 'react';

export type MediaGalleryConfig = {
  id?: string;
  open?: (media?: IMedia | IMedia[]) => void;
  close?: () => void;
};

export const MediaGalleryContext = createContext<MediaGalleryConfig>({});

export function useMediaGalleryContext() {
  return useContext(MediaGalleryContext);
}
